module.exports = __webpack_public_path__ + "img/IMG_8155_L.251351ab.webp";